import React, { useEffect, useRef, useState } from "react";
import BgColorDropdown from "../BgColorDropdown/bgDropdown";
import './userColor.css';
import { MindMapContext } from "../../Context/contex";
import useMindMapService from '../../hooks/useMindMapService';
import { emitAllocatedColor, emitUpdateMultiple } from "../../Socket/socket";
import { debounce } from "lodash";
import { useParams } from "react-router-dom";


const UserColor = React.memo(() => {
  
  const { documentId } = useParams();
  const { userColor, setUserColor, setNodes, userInfo, nodes, edges, setSavingData, setIsDocumentChanged } = MindMapContext();
  const [nodeBg, setNodeBg] = useState(null);

  // Stable ref so the debounced callback always calls the latest routing logic.
  const mindMapService = useMindMapService();
  const mindMapServiceRef = useRef(mindMapService);
  useEffect(() => { mindMapServiceRef.current = mindMapService; }, [mindMapService]);

  useEffect(() => {
    // Only a colour the user picked. On mount there is none, and setting null would wipe the colour the map just
    // loaded (the header mounts after the map), so every new node would be saved without a creator colour.
    if (nodeBg) {
      setUserColor(nodeBg);
      setSavingData({ isSaving: 'Saving...', lastSavedDateTime: '' });
      // Pre-compute the updated nodes so the snapshot is accurate before the
      // async React state update propagates.
      const updatedNodes = nodes.map((node) => {
        if (node.creatorId === userInfo.userId && node.data.allocatedColor !== nodeBg) {
          return { ...node, data: { ...node.data, allocatedColor: nodeBg } };
        }
        return node;
      });
      setNodes(updatedNodes);
      updateBorderColor(
        updatedNodes,
        edges,
        { nodeBg: nodeBg, userId: userInfo.userId, documentId: documentId }
      );
    }
  }, [nodeBg]);

  const updateBorderColor = useRef(debounce((updatedNodes, currentEdges, payload) => {
    mindMapServiceRef.current.updateMany(updatedNodes, { nodes: updatedNodes, edges: currentEdges });
    emitAllocatedColor(payload);
    setIsDocumentChanged(true);
  }, 400)).current;

  return (
    <div className="color-btn color-border" style={{ backgroundColor: `${userColor}` }}>
      <BgColorDropdown setNodeBg={setNodeBg} isIconVisible={false} />
    </div>
  );
})

export default UserColor;
